export const getGoogleClientId = () => {
  const metaElement = document.querySelector('meta[name="google-signin-client_id"]') as HTMLMetaElement
  return metaElement?.content
}
